import { theme as e } from "@lokalise/token-dictionary/theme-lokalise-dark.js";
import { base as o } from "./base.js";
import { generateDeprecatedThemeColors as r } from "../designTokens/color/deprecatedColors.js";
const t = r("dark"), c = {
  ...o,
  color: {
    ...e.color,
    deprecated: t
  },
  mode: e.mode
};
export {
  c as dark
};
//# sourceMappingURL=dark.js.map
